const extensionId = "abodjnpfbnnnhlnohdncncbokiiblgji"; 
const extensionIdDev = "hbfdhhiblmagmemijfbhnleofkcahlgc"; 

const DEFAULT_USER_IMG = "https://clipart-library.com/images/ATbrxjpyc.jpg";
const DEFAULT_USER_NAME = "Anonymous";
const DEFAULT_USER_FULL_NAME = "An anonymous person";


export { extensionId, extensionIdDev, DEFAULT_USER_IMG, DEFAULT_USER_NAME, DEFAULT_USER_FULL_NAME };
